// extracted by mini-css-extract-plugin
export var deleteModal = "_rp-0";